export const startsWithVowel = s => {
    const vowels = ['a', 'á', 'e', 'é', 'i', 'í', 'o', 'ó', 'ö', 'ő', 'u', 'ú', 'ü', 'ű'];
    return vowels.some(v => s.toLowerCase().startsWith(v));
};

export const getVowelAdjective = s => {
    return s ? (startsWithVowel(s) ? 'az' : 'a') : 'a(z)';
};

export const getGreetingByTime = () => {
    var d = new Date();
    var time = d.getHours();

    if (time < 10) return 'Jó reggelt';
    if (time > 18) return 'Szép estét';
    return 'Szép napot';
};

export const getItemByKeyValue = (combo, key, value) => {
    for (let i = 0; i < combo.length; i++)
        if (combo[i][key] === value)
            return combo[i];
    return null;
};

export const filterSettlementList = (countyCombo, settlementCombo, countyId) => {
    const countyID = countyId ? getItemByKeyValue(countyCombo, 'id', countyId).countyID : null;
    return settlementCombo.filter(item => ((!countyID || item.countyID === countyID) && item.primary));
};

export const filterSettlementListByArray = (countyCombo, settlementCombo, countyIdList) => {
    if (countyIdList.length > 0) {
        let list = [];
        for (let i = 0; i < countyIdList.length; i++)
            list = list.concat(filterSettlementList(countyCombo, settlementCombo, countyIdList[i]))
        return list.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
    } else return settlementCombo;
};

export const getAddressString = (countryCombo, settlementCombo, typesOfRoadCombo, country, zipCode, settlement, roadName, typesOfRoad, houseNumber, building, floor, door) => {
    if (country && zipCode && settlement && roadName && typesOfRoad && houseNumber) {
        let _settlement = getItemByKeyValue(settlementCombo, 'id', settlement).name;
        let _typesOfRoad = getItemByKeyValue(typesOfRoadCombo, 'id', typesOfRoad).name;

        return zipCode + ' ' + _settlement + ', ' + roadName + ' ' + _typesOfRoad + ' ' + houseNumber + (building ? (', ' + building + ' épület') : '') + (floor ? (', ' + floor + ' emelet') : '') + (door ? (', ' + door + ' ajtó') : '');
    } else {
        return null;
    }
};

export const convertDateToString = (date) => {
    const dateStr = date.getFullYear() + '-' + (date.getMonth() < 9 ? ('0' + (date.getMonth() + 1)) : (date.getMonth() + 1)) + '-' + (date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate());
    const timeOffset = -1 * date.getTimezoneOffset() / 60;
    const hour = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();
    const timeStr = 'T' + (hour < 10 ? ('0' + hour) : hour) + ':' + (minute < 10 ? ('0' + minute) : minute) + ':' + (second < 10 ? ('0' + second) : second) + '.000' + (timeOffset < 0 ? '-' : '+') + (timeOffset < 10 ? ('0' + timeOffset) : timeOffset) + ':00';
    return dateStr + timeStr;
};

// export const ConditionalWrap = ({ condition, wrap, children }) => condition ? wrap(children) : children;